// CRM 2.0 "Your CRM" card on the right rail (M2-F9, M2.23 / M2.24, DC-83).
// One line per open CRM 2.0 booking: the CRM's name and phone once final, else
// "Waiting to assign…" (paid) or "Assigned when the booking amount is fully paid".
// Shown only when the customer has a CRM 2.0 booking; same desktop-only rule as SalesManagerCard.
import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Card, useMediaQuery } from "@mui/material";
import PhoneCallIcon from "../../../Assets/Images/Common/phone12profile.svg";
import { getCrm2LeadBookings } from "../../../Services/Crm2Booking";
import { WAITRM } from "./useCrm2Booking";
import css from "./Crm2Booking.module.css";

const POLL_MS = 60 * 1000;

// placement "rail" (desktop right rail) or "below" (phone: under the unit cards, DC-146 (2))
export default function YourCrmCard({ style = {}, placement = "rail" }) {
	const narrow = useMediaQuery("(max-width:1024px)");
	const hide = placement === "rail" ? narrow : !narrow;
	const leadId = useSelector((state) => state.Auth.user?.leadId);
	const [list, setList] = useState([]);

	const load = useCallback(() => {
		if (!leadId) return;
		getCrm2LeadBookings(leadId)
			.then((data) => setList(Array.isArray(data) ? data : []))
			.catch((err) => console.warn("[crm2][portal] Your CRM not loaded", err.message));
	}, [leadId]);

	useEffect(() => {
		load();
	}, [load]);

	const waiting = list.some((b) => b.bookingState !== "APPLIED");
	useEffect(() => {
		if (!waiting) return;
		const id = setInterval(load, POLL_MS);
		return () => clearInterval(id);
	}, [waiting, load]);

	if (hide || !list.length) return null;
	return (
		<Card className={css.rail} style={{ boxShadow: "none", ...style }}>
			<div className={css.railT}>
				Your CRM <span className={css.newtag}>New</span>
			</div>
			<div className={css.railIn}>
				{list.map((b) => (
					<div key={b.allotmentPaymentId} className={css.ucrm}>
						<div className={css.k}>
							{b.unitNo} · {(b.projectName || "").split(" ").slice(0, 2).join(" ")}
						</div>
						{b.crm ? (
							<>
								<div className={css.n}>{b.crm.name}</div>
								{b.crm.phone && (
									<div className={css.r}>
										<img src={PhoneCallIcon} alt="call" />
										{b.crm.phone}
									</div>
								)}
							</>
						) : (
							<div className={`${css.n} ${css.nWait}`}>{b.bookingState === "SHORTLISTED" ? "Assigned when the booking amount is fully paid" : WAITRM}</div>
						)}
					</div>
				))}
			</div>
		</Card>
	);
}
